import { RequestLog } from '@engine/models'

interface QuoteStatusBadgeProps {
  log: RequestLog
}

export const QuoteStatusBadge = ({ log }: QuoteStatusBadgeProps) => {
  const response = log.tenantResponse?.content
  const isError = response?.rates?.some(r => r.status === 'error')
  let badgeClass
  let displayText = 'ok'

  if (!response?.rates?.length) {
    displayText = 'no rates'
    badgeClass = 'badge-warning'
  } else if (isError) {
    badgeClass = 'badge-error'
    const errorType = response.rates.find(e => e.status === 'error')?.errorType
    displayText = errorType || 'error'
  } else {
    badgeClass = 'badge-success'
  }

  return <span className={`badge badge-sm ${badgeClass}`}>{displayText}</span>
}
